"use client";

import { IconButton } from "@mui/material";
import { usePathname } from "next/navigation";
import { useCallback } from "react";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { inhomzEvents } from "@/app/(fevicol-inhomz)/_lib/events";
import { useInhomzTrack } from "@/app/(fevicol-inhomz)/_hooks/useInhomzTrack";

// `trackShare` opts a caller in to the share event (name only; the profile id is on the viewed event).
export default function ShareIconButton({
  profileName,
  trackShare = false
}) {
  const pathname = usePathname();
  const track = useInhomzTrack();
  const handleShare = useCallback(async () => {
    if (typeof window === "undefined") return;
    if (trackShare) {
      track(inhomzEvents.contractorProfile.SHARE_CLICKED, {
        contractor_name: profileName,
        placement: "header"
      });
    }
    const title = "Check this out!";
    const text = `${profileName}'s digital profile`;
    const getBaseUrl = () => {
      return window.location.origin || process.env.NEXT_PUBLIC_SITE_URL || "https://letsmultiply.co.in";
    };
    const shareUrl = window.location.href || `${getBaseUrl()}${pathname}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title,
          text,
          url: shareUrl
        });
      } catch (error) {
        if (error?.name === "AbortError") return;
        console.error("Error sharing content:", error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, profileName, trackShare]);
  return <div className="flex-shrink-0   flex justify-center items-center  p-4">
      <IconButton sx={{
      color: "var(--colorPrimaryOnColorPrimary)",
      width: 28,
      height: 28,
      padding: "4px"
    }} onClick={handleShare}>
        <ShareOutlinedIcon sx={{
        width: 24,
        height: 24
      }} />
      </IconButton>
    </div>;
}